import React from 'react';
import cls from 'classnames';
import { toAssetsExtUrl } from 'utils/assetsExtUrl';

const BlockedSessionContentView = ({
    onWatchFromHere,
    recordingImageUrl,
}) => {

    const defaultBackgroundUrl = 'https://assets-ext.bizzabo.com/bizzaboprod/image/upload/v1609850133/jsabgi76muwlfk8arqkf.png';

    return (
        <div className="live-broadcast-preview overflow-hidden">
            <img
                src={`${recordingImageUrl ? toAssetsExtUrl(recordingImageUrl) : defaultBackgroundUrl}`}
                className={cls('preview-image', {'preview-image-blurred': !!recordingImageUrl})}
            />
            {recordingImageUrl && <div className="preview-image-overlay" />}
            <div className="preview-image-caption text-center">
                <p className="font-size-20 padding-horizontal-small caption-title">
                    You&apos;re currently streaming this event from another device or tab
                </p>
                <p className="padding-horizontal-small">
                    Would you like to continue watching from here?
                </p>
                <button
                    className="text-uppercase bz-button font-size-13 custom-color color-1-background color-1-hover-opacity"
                    onClick={onWatchFromHere}
                >
                    Yes, Watch Here
                </button>
            </div>
        </div>
    );
};

export default BlockedSessionContentView;
